module.exports = __webpack_public_path__ + "static/media/moren@2x.da815b12.png";